import { Card, Table, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import LayoutWithMenu from 'components/Layout/LayoutWithMenu';
import { post } from 'core/fetch';
import { useEffect, useState } from 'react';

const { Title } = Typography;

interface TransactionRow {
  id: number;
  name: string;
  amount: number;
  discount_amount: number;
  paid_amount: number;
  channel: string | null;
  description: string | null;
  transaction_date: string;
}

function formatMNT(n: number): string {
  return new Intl.NumberFormat('mn-MN').format(n) + '₮';
}

interface CardTransactionLedgerProps {
  transactionType: 'credit' | 'debit';
  title: string;
}

const CardTransactionLedger = ({ transactionType, title }: CardTransactionLedgerProps) => {
  const [rows, setRows] = useState<TransactionRow[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    post<{ results: TransactionRow[]; total: number }>('/custom/card-transaction/list', {
      transaction_type: transactionType,
      limit: pageSize,
      page,
    })
      .then((response) => {
        setRows(response.results);
        setTotal(response.total);
      })
      .finally(() => setLoading(false));
  }, [transactionType, page, pageSize]);

  const columns: ColumnsType<TransactionRow> = [
    {
      title: 'Огноо',
      dataIndex: 'transaction_date',
      width: 160,
      render: (value: string) => (value ? new Date(value).toLocaleString('mn-MN') : '—'),
    },
    { title: 'Сурагч/Багш', dataIndex: 'name' },
    { title: 'Дүн', dataIndex: 'amount', align: 'right', render: formatMNT },
    { title: 'Хөнгөлөлт', dataIndex: 'discount_amount', align: 'right', render: formatMNT },
    { title: 'Төлсөн дүн', dataIndex: 'paid_amount', align: 'right', render: formatMNT },
    { title: 'Суваг', dataIndex: 'channel', render: (value: string | null) => value ?? '—' },
    { title: 'Тайлбар', dataIndex: 'description', render: (value: string | null) => value ?? '—' },
  ];

  return (
    <LayoutWithMenu className="px-3 lg:px-5">
      <Card>
        <Title level={4} style={{ marginBottom: 16 }}>
          {title}
        </Title>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={rows}
          loading={loading}
          pagination={{
            current: page + 1,
            pageSize,
            total,
            showSizeChanger: true,
            onChange: (nextPage, nextPageSize) => {
              setPage(nextPage - 1);
              setPageSize(nextPageSize);
            },
          }}
        />
      </Card>
    </LayoutWithMenu>
  );
};

export default CardTransactionLedger;
